var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChromeCastConnectedIcon = function SvgChromeCastConnectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 5.167a3.167 3.167 0 0 0-3.166 3.166v4.833h3V8.333c0-.092.074-.167.166-.167h30c.092 0 .167.075.167.167v23.333a.167.167 0 0 1-.167.167H23.5v3H35a3.167 3.167 0 0 0 3.167-3.166V8.333A3.167 3.167 0 0 0 35 5.167zM1.667 19.833c8.376 0 15.167 6.79 15.167 15.167h3c0-10.033-8.134-18.167-18.167-18.167zm0 6.667a8.5 8.5 0 0 1 8.5 8.5h3c0-6.351-5.149-11.5-11.5-11.5zm0 7.5a1 1 0 0 1 1 1h3a4 4 0 0 0-4-4zm30-22.333v16.666H22.5c-1.667-5.833-6.667-12.5-14.167-14.166v-2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgChromeCastConnectedIcon;